<template>
  <div id="notice">notice</div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
export default {
  mixins: [part],
  name: "notice",
};
</script>

<style>
</style>